import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import { Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import { useFlightsFilters } from 'legacyfrontend/contexts/FlightsFiltersContext';
import { useColors } from 'legacyfrontend/hooks/useColors';
import { forwardRef, useState } from 'react';
const Transition = forwardRef((props, ref) => {
  return <Slide direction='up' ref={ref} {...props} />;
});

const MobileFlightsFilter = ({ children }) => {
  const { handleResetFilters } = useFlightsFilters();
  const [open, setOpen] = useState(false);

  const { background } = useColors();

  const handleClickOpen = () => {
    setOpen((state) => !state);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <button
        onClick={handleClickOpen}
        style={{
          display: 'flex',
          position: 'fixed',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          padding: '10px 20px',
          borderRadius: '25px',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          gap: 10,
          alignItems: 'center',
          zIndex: 10000,
        }}
      >
        {!open ? <TuneIcon /> : <CloseIcon />}
        <p>Filtros</p>
      </button>
      <Dialog
        TransitionComponent={Transition}
        disableEnforceFocus
        disableScrollLock={false}
        fullScreen
        onClose={handleClose}
        open={open}
        slotProps={{
          backdrop: {
            style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          },
        }}
      >
        <AppBar sx={{ position: 'relative', backgroundColor: background }}>
          <Toolbar>
            <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <Typography component='div' sx={{ ml: 2, flex: 1 }} variant='h6'>
              Filtros
            </Typography>
            <button
              className='aside-flights-filters__clean-btn-mobile  justify-between'
              onClick={handleResetFilters}
            >
              Limpiar
            </button>
          </Toolbar>
        </AppBar>
        <DialogContent
          sx={{
            overflowY: 'scroll',
            maxHeight: '90vh',
            padding: 0,
          }}
        >
          {children}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MobileFlightsFilter;
